import { TsDOM as q } from '@/scripts/core/TsDOM'
import { ProductForm } from '@/scripts/product/product-form'

q.safeDefineElement(ProductForm)
